<template>
    <PageFooter :project-status="projectStatus">
        <template v-if="logged">
            <PageActionsButton
                v-if="!hasChanges && actions.length"
                :actions="actions"
                :title="$t('shared.actions')"
            />
            <ButtonSecondaryIconSm
                v-if="!isCreatorShown"
                :disabled="hasChanges"
                @click="$emit('publish')"
            >
                <RocketIcon />
            </ButtonSecondaryIconSm>
            <ButtonPrimaryIconSm
                v-if="!isCreatorShown"
                :disabled="!hasChanges"
                @click="$emit('save')"
            >
                <SaveIcon />
            </ButtonPrimaryIconSm>
        </template>
        <template v-else>
            <ButtonTertiarySm>{{ $t("shared.log_in") }}</ButtonTertiarySm>
            <ButtonPrimarySm>{{ $t("shared.sign_up") }}</ButtonPrimarySm>
        </template>
        <ButtonSecondarySm
            v-if="isCreatorShown"
            @click="$emit('skipGenerator')"
            :disabled="!canSkipGenerator"
        >
            <SkipForwardIcon />
            <span>{{ $t("shared.creator.skip") }}</span>
        </ButtonSecondarySm>
    </PageFooter>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { PageFooter, PageActionsButton } from "@easy/ui/page-components";
import { RocketIcon, SaveIcon, SkipForwardIcon } from "@easy/ui/icons";
import {
    ButtonSecondaryIconSm,
    ButtonPrimaryIconSm,
    ButtonTertiarySm,
    ButtonPrimarySm,
    ButtonSecondarySm,
} from "@easy/ui/buttons";

export default {
    emits: ["save", "publish", "skipGenerator"],
    components: {
        SkipForwardIcon,
        PageFooter,
        PageActionsButton,
        ButtonSecondarySm,
        ButtonSecondaryIconSm,
        RocketIcon,
        SaveIcon,
        ButtonPrimaryIconSm,
        ButtonTertiarySm,
        ButtonPrimarySm,
    },
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
        canSkipGenerator: {
            type: Boolean,
            default: true,
        },
        hasChanges: {
            type: Boolean,
            default: false,
        },
        isCreatorShown: {
            type: Boolean,
            default: false,
        },
        project: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapState(["lang"]),
        ...mapGetters(["logged", "isPublished"]),
        projectStatus() {
            if (this.hasChanges) {
                return { type: "neutral", label: this.$t("shared.unsaved") };
            }
            if (this.isPublished(this.project)) {
                return { type: "success", label: this.$t("shared.published") };
            }
            return { type: "warning", label: this.$t("shared.draft") };
        },
    },
};
</script>
